import { Box, Typography } from '@mui/material';
import React from 'react';
import LoadingBackdrop from 'components/LoadingBackdrop';
import { useNotificationProvider } from 'hooks';
import AttachmentCard from 'containers/pages/CANguard/components/attachmentCard/AttachmentCard';
import { deleteBucketFile } from 'api/canpark/bucket/deleteFile';
import { TicketAttachment } from '../../types/ticket';

const TicketAttachments: React.FC<{
	attachments: TicketAttachment[];
	setAttachments?: (attachments: TicketAttachment[]) => void;
	disableDelete?: boolean;
}> = (props) => {
	const { attachments: ticketAttachments, disableDelete } = props;
	const [pendingDelete, setPendingDelete] = React.useState<boolean>(false);
	const { notifySuccess, notifyError } = useNotificationProvider();

	const deleteAttachment = async (fileIDToDelete: string) => {
		setPendingDelete(true);
		try {
			await deleteBucketFile(fileIDToDelete);
			const updatedAttachments = ticketAttachments.filter(
				(item) => item.AttachmentID !== fileIDToDelete,
			);
			props.setAttachments?.(updatedAttachments);
			notifySuccess('File deleted successfully');
		} catch (e) {
			console.error('Error in file deletion: ', e);
			notifyError('Error deleting file');
		} finally {
			setPendingDelete(false);
		}
	};

	return (
		<Box display={'flex'} flexDirection={'column'} gap={2}>
			{ticketAttachments.length === 0 && (
				<Typography
					textAlign={'center'}
					variant="body1"
					color={'warning.main'}
					fontStyle={'italic'}
				>
					No attachments uploaded
				</Typography>
			)}
			{ticketAttachments.map((attachment, index) => (
				<AttachmentCard
					key={index}
					contentType={attachment.ContentType}
					name={attachment.Name}
					id={attachment.AttachmentID}
					size={attachment.Size}
					index={index}
					source="bucket"
					onConfirmDelete={(id) => deleteAttachment(id as string)}
					disableDelete={disableDelete}
				/>
			))}
			<LoadingBackdrop open={pendingDelete} />
		</Box>
	);
};

export default TicketAttachments;
